import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { WalletBalanceBadge } from '@root/entities/wallet/ui/desktop'

import type { OrderModel } from '@root/entities/order/atoms'
import type { ClassNameProps } from '@root/shared/react'

// TODO: Wait for designer for design changes

type Props = {
  order: OrderModel
} & ClassNameProps

export const OrdersTableWalletCell: React.FC<Props> = ({
  className,
  order: { order },
}) => {
  const [wallet] = useAtom(order.wallet)

  if (!wallet) {
    return <>-</>
  }

  return (
    <Root className={className}>
      <WalletBalanceBadge currency={order.pair.quote} wallet={wallet} />
    </Root>
  )
}

const Root = styled.div``
